"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderStatus = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var WorkOrderStatus;
(function (WorkOrderStatus) {
    /*
    This is essentially the Api-schema and it might be worth converting
    */
    WorkOrderStatus.Schema = centralized_zod_1.z.enum([
        "Planerad",
        "Bokad",
        "Bekräftad",
        "Completed",
        "Canceled",
        "Klarmarkerad av hantverkare",
    ]);
})(WorkOrderStatus || (WorkOrderStatus = {}));
exports.WorkOrderStatus = WorkOrderStatus;
